import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { ExtendedSecuritySummaryModel } from '../../../models/extended-security-summary.model';
import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-facts-and-figures',
    templateUrl: './facts-and-figures.component.html',
    styleUrls: ['./facts-and-figures.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FactsAndFiguresComponent implements OnInit {
    items: ExtendedSecuritySummaryModel[] = [];
    get hasSubSection(): boolean {
        return this.items.length > 0 && this.items.some(i => i.traderegisterNumberOfShares !== i.numberOfShares);
    }
    get shareholdersCountWithVotesSum(): number {
        return this.items.reduce((a, b) => a + b.shareholdersCountWithVotes, 0);
    }
    get votesSum(): number {
        return this.items.reduce((a, b) => a + b.votes, 0);
    }
    get shareholdersCountSum(): number {
        return this.items.reduce((a, b) => a + b.shareholdersCount, 0);
    }
    get registeredSharesWithVotesSum(): number {
        return this.items.reduce((a, b) => a + b.registeredSharesWithVotes, 0);
    }
    get registeredSharesSum(): number {
        return this.items.reduce((a, b) => a + b.registeredShares, 0);
    }
    get traderegisterNumberOfSharesSum(): number {
        return this.items.reduce((a, b) => a + b.traderegisterNumberOfShares, 0);
    }
    get numberOfSharesSum(): number {
        return this.items.reduce((a, b) => a + b.numberOfShares, 0);
    }
    get traderegisterCapitalSum(): number {
        return this.items.reduce((a, b) => a + b.traderegisterNumberOfShares * b.nominalValue, 0);
    }
    get capitalSum(): number {
        return this.items.reduce((a, b) => a + b.numberOfShares * b.nominalValue, 0);
    }
    get conditionalCapitalSum(): number {
        return this.items.reduce((a, b) => a + (b.numberOfShares - b.traderegisterNumberOfShares) * b.nominalValue, 0);
    }

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getSecurities().subscribe(r =>
            r.value.forEach(i => {
                const registeredSharesPercent = +((i.registeredShares / i.numberOfShares) * 100).toFixed(2);
                const dispoPercent = +(100 - registeredSharesPercent).toFixed(2);

                this.items.push(
                    new ExtendedSecuritySummaryModel({
                        ...i,
                        registeredSharesPercent,
                        dispoPercent
                    })
                );
            })
        );
    }
}
